<ion-header class="absolute transparent">
    <app-header [middleIcon]="false" [hide930]="true"></app-header>
</ion-header>
<ion-content class="theme-{{userService.theme}}">
    <div class="content">
        <div class="bg-header">
            <div class="wrap-logo">
                <img class="side-logo" [src]="userService.companyLogo">
                <div class="title">{{title}}</div>
            </div>
        </div>
    </div>
    <div class="coaching-wrap content-wrap">
        <div class="content">
            <div class="group">
                <div class="btn-group">
                    <div class="item">
                      <div (click)="tryAgain()" class="btn">{{ "__STATIC_PAGES_TRY_AGAIN__" | translate }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ion-content>


